const denimSizes = ["23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34"];
const apparelSizes = ["XS", "S", "M", "L", "XL"];

const catalog = [
  {
    name: 'Aster Straight Jean 30" Deep Indigo', category: "Jeans", fit: "Straight", badge: "NEW", price: "159.00",
    fitLine: 'Straight | High rise | 30" inseam', colors: ["Deep Indigo", "Black Rinse"], material: "13oz rigid organic cotton denim",
    description: ["A clean straight-leg jean with a close waist and an easy line from hip to hem.", "The deep indigo rinse is designed to soften gradually and develop a personal finish with wear."],
    Features: ["High-rise waist", "Five-pocket construction", "Zip fly", "100% organic cotton"],
  },
  {
    name: 'Elara Wide Jean 32" Washed Black', category: "Jeans", fit: "Wide & Barrel", badge: "NEW", price: "169.00",
    fitLine: 'Wide leg | High rise | 32" inseam', colors: ["Washed Black", "Graphite"], material: "12.5oz rigid cotton denim",
    description: ["A full-length wide jean balanced by a neat, high-rise waist.", "A soft charcoal wash gives the structured silhouette a relaxed, worn-in character."],
    Features: ["High rise", "Full-length wide leg", "Antique silver-tone hardware", "Rigid denim"],
  },
  {
    name: 'Solace Barrel Jean 29" Antique Blue', category: "Jeans", fit: "Wide & Barrel", badge: "NEW", price: "175.00",
    fitLine: 'Barrel | Mid rise | 29" inseam', colors: ["Antique Blue", "Soft Stone"], material: "13oz regenerative cotton denim",
    description: ["A sculpted barrel jean with considered volume through the leg and a tapered ankle.", "Curved side seams create shape without sacrificing everyday ease."],
    Features: ["Mid rise", "Curved barrel leg", "Twisted side seam", "Regenerative cotton blend"],
  },
  {
    name: 'Meridian Slim Jean 29" Ink Rinse', category: "Jeans", fit: "Slim", badge: null, price: "149.00",
    fitLine: 'Slim | Mid rise | 29" inseam', colors: ["Ink Rinse", "Clean Black"], material: "Comfort-stretch cotton denim",
    description: ["A refined slim jean that follows the body without feeling restrictive.", "The dark, clean rinse makes it an understated option for workdays and evenings."],
    Features: ["Mid rise", "Slim straight leg", "Comfort stretch", "Zip fly"],
  },
  {
    name: 'Arden Bootcut Jean 32" Vintage Indigo', category: "Jeans", fit: "Bootcut & Flare", badge: "BESTSELLER", price: "165.00",
    fitLine: 'Bootcut | High rise | 32" inseam', colors: ["Vintage Indigo", "Dark Rinse"], material: "12oz comfort-stretch denim",
    description: ["A long bootcut jean shaped close through the thigh before opening subtly at the hem.", "Authentic highs and lows bring depth to the vintage indigo wash."],
    Features: ["High rise", "Long bootcut leg", "Comfort stretch", "Classic five pockets"],
  },
  {
    name: 'Sable Flare Jean 32" Charcoal', category: "Jeans", fit: "Bootcut & Flare", badge: null, price: "169.00",
    fitLine: 'Flare | High rise | 32" inseam', colors: ["Charcoal", "Midnight"], material: "Soft stretch cotton denim",
    description: ["A confident high-rise flare with a fluid line and a clean charcoal finish.", "The fabric offers gentle recovery while maintaining the shape of the leg."],
    Features: ["High-rise fit", "Fitted thigh", "Flared hem", "Shape-recovery stretch"],
  },
  {
    name: 'Coda High-Rise Jean 28" Clean Blue', category: "Jeans", fit: "Straight", badge: "NEW", price: "155.00",
    fitLine: 'Straight | High rise | 28" inseam', colors: ["Clean Blue", "Light Vintage"], material: "12.75oz non-stretch cotton denim",
    description: ["A cropped straight jean designed to sit cleanly at the ankle.", "The clear blue wash and restrained detailing make it a versatile everyday staple."],
    Features: ["High rise", "Cropped straight leg", "Clean hem", "Rigid cotton denim"],
  },
  {
    name: 'Marlow Relaxed Jean 31" Ecru', category: "Jeans", fit: "Wide & Barrel", badge: null, price: "149.00",
    fitLine: 'Relaxed | Mid rise | 31" inseam', colors: ["Ecru", "Warm Stone"], material: "Undyed cotton and recycled cotton denim",
    description: ["A relaxed jean cut with room through the seat and leg for effortless wear.", "The undyed ecru tone reveals the natural flecks and character of the cotton."],
    Features: ["Mid rise", "Relaxed leg", "Undyed finish", "Recycled cotton blend"],
  },
  {
    name: 'Lumen Crop Jean 27" Mid Stone', category: "Jeans", fit: "Slim", badge: "FINAL SALE", price: "89.00", compareAtPrice: "139.00",
    fitLine: 'Cropped slim | Mid rise | 27" inseam', colors: ["Mid Stone", "Pale Blue"], material: "11.5oz comfort-stretch denim",
    description: ["A precise cropped jean with a softly faded mid-blue wash.", "Built with subtle stretch for an easy fit that returns to shape."],
    Features: ["Mid rise", "Ankle crop", "Comfort stretch", "Soft stone wash"],
  },
  {
    name: 'Cove Taper Jean 29" Soft Grey', category: "Jeans", fit: "Straight", badge: null, price: "145.00",
    fitLine: 'Tapered | High rise | 29" inseam', colors: ["Soft Grey", "Washed Black"], material: "12.5oz rigid cotton denim",
    description: ["A high-rise jean with a roomy upper leg and a quiet taper through the ankle.", "The soft grey wash is neutral, tonal and easy to style year-round."],
    Features: ["High rise", "Tapered leg", "Five-pocket styling", "Rigid denim"],
  },
  {
    name: "Axis A-Line Skirt Dark Rinse", category: "Shorts & Skirts", fit: "A-Line", badge: "NEW", price: "129.00",
    fitLine: "A-line | High rise | Mini length", colors: ["Dark Rinse", "Vintage Blue"], material: "Rigid organic cotton denim",
    description: ["A clean A-line denim skirt with a structured waist and subtle flare.", "Minimal finishing keeps the deep rinse feeling polished and modern."],
    Features: ["High-rise waistband", "A-line silhouette", "Front patch pockets", "Rigid organic cotton"],
  },
  {
    name: "Alba Denim Midi Skirt Soft Stone", category: "Shorts & Skirts", fit: "Midi", badge: null, price: "139.00",
    fitLine: "Column | High rise | Midi length", colors: ["Soft Stone", "Deep Indigo"], material: "12oz cotton denim",
    description: ["A long column skirt with a back split for natural movement.", "Tonal stitching and a soft stone wash give the silhouette a calm, refined finish."],
    Features: ["High rise", "Midi length", "Back walking split", "Five-pocket detailing"],
  },
  {
    name: "Coastline Relaxed Short Sun Fade", category: "Shorts & Skirts", fit: "Relaxed", badge: "NEW", price: "99.00",
    fitLine: "Relaxed | Mid rise | Longline", colors: ["Sun Fade", "Clean Blue"], material: "Lightweight cotton denim",
    description: ["A longer relaxed denim short designed with space through the thigh.", "The sun-faded wash brings the ease of a well-loved summer pair from the first wear."],
    Features: ["Mid rise", "Longline cut", "Finished hem", "Lightweight rigid denim"],
  },
  {
    name: "Atelier Tailored Short Chalk", category: "Shorts & Skirts", fit: "Tailored", badge: null, price: "119.00",
    fitLine: "Tailored | High rise | Relaxed thigh", colors: ["Chalk", "Cocoa"], material: "Cotton twill with recycled fibres",
    description: ["A refined high-rise short with front pleats and a softly structured leg.", "The chalk tone pairs easily with tonal knitwear and crisp shirting."],
    Features: ["High rise", "Front pleats", "Slant pockets", "Hook-and-bar closure"],
  },
  {
    name: "Essential Rib Tank Ecru", category: "Tops", fit: "Fitted", badge: null, price: "59.00",
    fitLine: "Fitted | Hip length", colors: ["Ecru", "Black", "Cocoa"], material: "Organic cotton rib",
    description: ["A close rib tank cut with a clean scoop neckline and wide straps.", "Soft organic cotton makes it an easy foundation for denim and tailoring."],
    Features: ["Fitted shape", "Scoop neck", "Wide straps", "Organic cotton rib"],
  },
  {
    name: "Studio Baby Tee White", category: "Tops", fit: "Fitted", badge: "NEW", price: "55.00",
    fitLine: "Fitted | Cropped length", colors: ["White", "Black", "Dusty Rose"], material: "Mid-weight cotton jersey",
    description: ["A compact crew-neck tee with a gently cropped proportion.", "The substantial jersey has a smooth finish and holds its shape through repeated wear."],
    Features: ["Crew neck", "Short sleeve", "Cropped body", "Mid-weight cotton jersey"],
  },
  {
    name: "Column Long Sleeve Tee Black", category: "Tops", fit: "Fitted", badge: null, price: "75.00",
    fitLine: "Fitted | Full length", colors: ["Black", "White", "Charcoal"], material: "Cotton-modal jersey",
    description: ["A fine long-sleeve layer with a close fit and an elongated sleeve.", "The cotton-modal jersey feels smooth against the skin while retaining clean lines."],
    Features: ["Close fit", "Crew neckline", "Long sleeve", "Cotton-modal blend"],
  },
  {
    name: "Transit Oversized Shirt Blue Stripe", category: "Tops", fit: "Oversized", badge: null, price: "125.00",
    fitLine: "Oversized | Longline", colors: ["Blue Stripe", "White"], material: "Organic cotton poplin",
    description: ["A relaxed striped shirt with a dropped shoulder and curved longline hem.", "Crisp cotton poplin makes it useful as a light layer or a standalone piece."],
    Features: ["Oversized fit", "Dropped shoulder", "Curved hem", "Organic cotton poplin"],
  },
  {
    name: "Linea Denim Midi Dress Deep Indigo", category: "Dresses & Jumpsuits", fit: "Column", badge: "NEW", price: "149.00",
    fitLine: "Column | Midi length", colors: ["Deep Indigo", "Washed Black"], material: "Lightweight cotton denim",
    description: ["A sleeveless denim column dress shaped with subtle waist seaming.", "A two-way front zip and deep indigo rinse keep the piece utilitarian yet refined."],
    Features: ["Midi length", "Front zip", "Side pockets", "Lightweight rigid denim"],
  },
  {
    name: "Field Utility Dress Worn Blue", category: "Dresses & Jumpsuits", fit: "Relaxed", badge: null, price: "159.00",
    fitLine: "Relaxed | Midi length", colors: ["Worn Blue", "Ecru"], material: "Washed cotton denim",
    description: ["A relaxed utility dress with considered pockets and an adjustable waist tab.", "The worn-blue finish gives the structured design a soft, lived-in hand."],
    Features: ["Relaxed fit", "Utility pockets", "Adjustable waist", "Midi length"],
  },
  {
    name: "Workshop Denim Jacket Mid Blue", category: "Jackets", fit: "Regular", badge: "BESTSELLER", price: "175.00",
    fitLine: "Regular | Hip length", colors: ["Mid Blue", "Deep Indigo"], material: "13oz rigid organic cotton denim",
    description: ["A considered take on the classic denim jacket with a clean shoulder and compact body.", "Copper-toned hardware and authentic washing give it character without excess detailing."],
    Features: ["Regular fit", "Chest patch pockets", "Waist adjusters", "Rigid organic cotton"],
  },
  {
    name: "Arc Oversized Denim Bomber Tonal Blue", category: "Jackets", fit: "Oversized", badge: "NEW", price: "169.00",
    fitLine: "Oversized | Cropped bomber", colors: ["Tonal Blue", "Washed Black"], material: "Mid-weight cotton denim",
    description: ["An oversized denim bomber with a curved sleeve and softly gathered hem.", "Tonal blue finishing keeps the volume modern and understated."],
    Features: ["Oversized fit", "Zip front", "Elasticated hem", "Fully lined"],
  },
  {
    name: "Interval Cropped Jacket Washed Black", category: "Jackets", fit: "Cropped", badge: null, price: "165.00",
    fitLine: "Boxy | Cropped length", colors: ["Washed Black", "Stone Grey"], material: "12.5oz rigid cotton denim",
    description: ["A boxy cropped jacket with a clean collar and slightly extended shoulder.", "The washed-black surface adds quiet depth to the minimal construction."],
    Features: ["Cropped boxy fit", "Extended shoulder", "Front welt pockets", "Rigid denim"],
  },
  {
    name: "Foundry Denim Vest Natural Ecru", category: "Jackets", fit: "Relaxed", badge: null, price: "155.00",
    fitLine: "Relaxed | Hip length", colors: ["Natural Ecru", "Dark Rinse"], material: "Undyed cotton denim",
    description: ["A sleeveless denim layer with a relaxed shoulder and subtle utility influence.", "Natural ecru cotton keeps the structured shape light and versatile."],
    Features: ["Sleeveless cut", "Relaxed fit", "Patch pockets", "Undyed cotton denim"],
  },
  {
    name: "Harbor Chore Jacket Light Indigo", category: "Jackets", fit: "Relaxed", badge: "NEW", price: "159.00",
    fitLine: "Relaxed | Hip length", colors: ["Light Indigo", "Deep Indigo"], material: "12oz washed cotton denim",
    description: ["A relaxed chore jacket with an easy shoulder and practical patch pockets.", "The light-indigo wash and tonal seams give this everyday layer a clean, familiar finish."],
    Features: ["Relaxed fit", "Four patch pockets", "Button front", "Washed cotton denim"],
  },
  {
    name: 'Nova Straight Jean 31" Faded Indigo', category: "Jeans", fit: "Straight", badge: "NEW", price: "165.00",
    fitLine: 'Straight | Mid rise | 31" inseam', colors: ["Faded Indigo", "Deep Blue"], material: "12.5oz washed organic cotton denim",
    description: ["An easy straight-leg jean with a balanced mid rise and full-length finish.", "A softly faded indigo wash gives the rigid denim an authentic, already-worn character."],
    Features: ["Mid rise", "Full-length straight leg", "Five-pocket construction", "Organic cotton denim"],
  },
  {
    name: "Contour Rib Long Sleeve Cocoa", category: "Tops", fit: "Fitted", badge: null, price: "79.00",
    fitLine: "Fitted | Hip length", colors: ["Cocoa", "Black", "Ecru"], material: "Organic cotton-modal rib",
    description: ["A close-fitting long-sleeve top with a softly scooped neckline.", "Fine cotton-modal rib creates a smooth, flexible layer designed for everyday wear."],
    Features: ["Close fit", "Scoop neckline", "Full-length sleeve", "Organic cotton-modal rib"],
  },
  {
    name: "Form Denim Jumpsuit Washed Black", category: "Dresses & Jumpsuits", fit: "Relaxed", badge: "NEW", price: "179.00",
    fitLine: "Relaxed | Straight leg | Full length", colors: ["Washed Black", "Mid Blue"], material: "Lightweight washed cotton denim",
    description: ["A relaxed denim jumpsuit shaped with a clean collar, straight leg and adjustable waist.", "The washed-black finish softens the utility-inspired silhouette for effortless everyday styling."],
    Features: ["Relaxed fit", "Button front", "Adjustable waist tabs", "Utility pockets"],
  },
];

const productData = catalog.map((product, index) => {
  const id = index + 1;
  const imageId = id > 25 ? [1, 16, 19][id - 26] : id;
  const imageNumber = String(imageId).padStart(2, "0");
  const imageExtension = imageId === 9 || imageId === 10 || imageId === 25 ? "png" : "webp";
  const isDenimBottom = product.category === "Jeans" || product.category === "Shorts & Skirts";

  return {
    id,
    brand: "nartvmora",
    compareAtPrice: null,
    stock: 8 + ((id * 7) % 19),
    size: isDenimBottom ? denimSizes : apparelSizes,
    fitNotes: [
      "Fits true to size; choose your usual size.",
      isDenimBottom ? "Model wears size 26." : "Model wears size S.",
    ],
    fabricDetails: [
      product.material,
      "Cold gentle machine wash inside out. Line dry in shade.",
    ],
    image: `/products/p${imageNumber}.${imageExtension}`,
    images: [`/products/p${imageNumber}.${imageExtension}`, `/products/p${imageNumber}-detail.${imageExtension}`],
    ...product,
  };
});

export default productData;
